import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    drawerState: null,
    // tenant switch in Settings > Configurations; hides the navbar "What's new" button
    featureToursEnabled: false
  },
  mutations: {
    toggleDrawerState(state) {
      state.drawerState = !state.drawerState
    },
    setFeatureToursEnabled(state, enabled) {
      state.featureToursEnabled = !!enabled
    }
  },
  actions: {
  },
  modules: {
  }
})
